export const getApplicationSettings = (state, feature) =>
  state.application[feature]
export const getSourcesListSettings = state =>
  getApplicationSettings(state, 'sourcesList')
export const getSetupSettings = state => getApplicationSettings(state, 'setup')
export const getAppSettings = state => getApplicationSettings(state, 'app')
export const getSourceIntegrationsSettings = state =>
  getApplicationSettings(state, 'sourceIntegrations')
export const getSourceSchemaSettings = state =>
  getApplicationSettings(state, 'sourceSchema')
export const getSourceSettingsSettings = state =>
  getApplicationSettings(state, 'sourceSettings')
export const getEnableSettings = state =>
  getApplicationSettings(state, 'enable')
export const getPartnersSettings = state =>
  getApplicationSettings(state, 'partners')
export const getSourceDebuggerSettings = state =>
  getApplicationSettings(state, 'sourceDebugger')

export const getWorkspaceSettingsSettings = state =>
  getApplicationSettings(state, 'workspaceSettings')
